// extracted by mini-css-extract-plugin
module.exports = {"languate_select":"LanguageSelect_languate_select__1hiNU","lang":"LanguageSelect_lang__3lSei","facebook":"LanguageSelect_facebook__3HaY4","mail":"LanguageSelect_mail__nu-mv"};